import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/device_test_reports',
  component: Management,
  redirect: '/device_test_reports/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/device_test_reports/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listDeviceTestReports
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/device_test_reports/ListTable'),
          meta: {
            auth: Auth.listDeviceTestReports,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/device_test_reports/DetailLayout'),
      meta: {
        auth: Auth.showDeviceTestReport
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/device_test_reports/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showDeviceTestReport
          }
        }
      ]
    }
  ]
}
